import { ReactNode, useState } from 'react';
import { SelectLocale } from '../SelectLocale/SelectLocale';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent } from '@mui/material';

export const SelectLanguage = () => {
	// hooks
	const { i18n } = useTranslation();

	// state
	const [locale, setLocale] = useState<string>('en-US');

	const handleChangeLang = (e: SelectChangeEvent<unknown>, child: ReactNode) => {
		const { value } = e.target as HTMLInputElement;
		const localeArray = value.split('-');
		const lang = localeArray[0];

		// change lang
		i18n.changeLanguage(lang);
		sessionStorage.setItem('language', lang);
		setLocale(value);
	};

	return <SelectLocale onChange={handleChangeLang} value={locale} />;
};
